import React, {
  type PropsWithChildren,
  useEffect,
  useMemo,
  useRef,
} from "react";

import clsx from "clsx";

import { type TableSelection } from "@devexpress/dx-react-grid-bootstrap4";
import { CustomCheckbox } from "@shared/custom-checkbox";

import { usePerformanceTrackingTableSelectionState } from "../../../hooks/use-selection-state";
import { useAllSelectedRowIds } from "../../contexts";

export const TableSelectionHeaderCell = ({
  someSelected,
}: PropsWithChildren<TableSelection.HeaderCellProps>) => {
  const [allSelectedRowIds] = useAllSelectedRowIds();

  const [, setSelectionState] = usePerformanceTrackingTableSelectionState();

  const checkboxRef = useRef<HTMLInputElement>(null);

  const isIntermediate = useMemo(() => {
    return someSelected;
  }, [someSelected]);

  const isSelected = useMemo(() => {
    if (someSelected) {
      return true;
    }
    if (!allSelectedRowIds.length) {
      return false;
    }
    return true;
  }, [allSelectedRowIds.length, someSelected]);

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = isIntermediate;
    }
  }, [isIntermediate, someSelected]);

  return (
    <th
      className={clsx(
        "left-0 dx-g-bs4-header-cell text-nowrap border-right",
        "dx-g-bs4-fixed-cell position-sticky z-2",
      )}
    >
      <div className="flex items-center justify-center w-full h-full">
        <CustomCheckbox
          ref={checkboxRef}
          checked={isSelected}
          onChange={() => {
            if (isSelected) {
              setSelectionState((prev) => ({
                selectedRowIds: [],
                deselectedRowIds:
                  prev.deselectedRowIds.concat(allSelectedRowIds),
              }));
            } else {
              setSelectionState({
                selectedRowIds: [],
                deselectedRowIds: [],
              });
            }
          }}
        />
      </div>
      <div className="absolute h-[45%] w-[1px] top-[27.5%] right-0 bg-gray-1" />
    </th>
  );
};
